import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import IconButton from "../../components/common/IconButton";
import { MdKeyboardBackspace } from "react-icons/md";

import { setQuotationType } from "./quotationSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { checkAcessRights } from "../../_helper/helper";
import { INSERT_ACCESS } from "../../_contstants/common";

import PackageQuotationGridComponent from "./PackageQuotation";
import FlightQuotationGridComponent from "./FlightQuotation";
import HotelQuotationGridComponent from "./HotelQuotation";
import VisaQuotationGridComponent from "./VisaQuotation";

const Quotation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const InquiryID = location.state?.InquiryID;
  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;

  const QuotationType = useAppSelector(
    (state) => state.quotation.QuotationType
  );

  const handleCreate = (path: string, ID: number, type: string) => {
    navigate(path, {
      state: {
        InquiryID: type === "InquiryID" ? ID : null,
        LeadID: type === "LeadID" ? ID : null,
        ContactID: type === "ContactID" ? ID : null,
      },
    });
  };

  const handleSelect = (QuotType: string) => {
    dispatch(setQuotationType(QuotType));
  };

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconButton
              fillMode="solid"
              title="Back"
              onClick={() => navigate(-1)}
              icon={MdKeyboardBackspace}
              iconClassName="absolute-position"
              style={{ height: 30 }}
              iconStyle={{ fontSize: "20px" }}
            />
            <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
              Quotation List
            </Typography.h4>
          </div>
          {isAddAccess && (
            <Button
              onClick={() => {
                if (InquiryID) {
                  handleCreate(
                    `/quotation/${QuotationType}/create`,
                    InquiryID,
                    "InquiryID"
                  );
                } else if (LeadID) {
                  handleCreate(
                    `/quotation/${QuotationType}/create`,
                    LeadID,
                    "LeadID"
                  );
                } else if (ContactID) {
                  handleCreate(
                    `/quotation/${QuotationType}/create`,
                    ContactID,
                    "ContactID"
                  );
                } else {
                  handleCreate(
                    `/quotation/${QuotationType}/create`,
                    0,
                    "Other"
                  );
                }
              }}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New"}
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem className="d-flex gap-2 mb-2">
          <Button
            fillMode={QuotationType === "package" ? "solid" : "outline"}
            onClick={() => handleSelect("package")}
            themeColor="primary"
          >
            Package
          </Button>
          <Button
            fillMode={QuotationType === "flight" ? "solid" : "outline"}
            onClick={() => handleSelect("flight")}
            themeColor="primary"
          >
            Flight
          </Button>
          <Button
            fillMode={QuotationType === "hotel" ? "solid" : "outline"}
            onClick={() => handleSelect("hotel")}
            themeColor="primary"
          >
            Hotel
          </Button>
          <Button
            fillMode={QuotationType === "visa" ? "solid" : "outline"}
            onClick={() => handleSelect("visa")}
            themeColor="primary"
          >
            Visa
          </Button>
        </GridLayoutItem>
        <GridLayoutItem>
          {QuotationType === "package" && <PackageQuotationGridComponent />}
          {QuotationType === "flight" && <FlightQuotationGridComponent />}
          {QuotationType === "hotel" && <HotelQuotationGridComponent />}
          {QuotationType === "visa" && <VisaQuotationGridComponent />}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default Quotation;
